import moment from 'moment'
import { SERVER_DATETIME_FORMAT } from '../constants'

export const isFinalOfferEnabled = (biddingStatus, featureFlags) => {
  return (
    featureFlags['fe.resi.reo.final_offer_sellers'] &&
    !biddingStatus.isAuctionInProgress &&
    !biddingStatus.hasUserWonAuction &&
    biddingStatus.auctionSequence >= 5 &&
    biddingStatus.hasHighestUserBid
  )
}

export const hasFinalOffer = (finalOffer = {}) => {
  return Boolean(finalOffer.post_auction_offer_id)
}

export const canSubmitFinalOffer = (
  biddingStatus,
  featureFlags,
  finalOffer
) => {
  if (!biddingStatus.submitOfferDeadline) return false
  return (
    isFinalOfferEnabled(biddingStatus, featureFlags) &&
    !hasFinalOffer(finalOffer) &&
    moment().isBefore(biddingStatus.submitOfferDeadline)
  )
}

export const getExpireDate = (finalOffer = {}) => {
  return finalOffer.expire_date
    ? moment(finalOffer.expire_date, SERVER_DATETIME_FORMAT)
    : null
}

export const getAmount = (finalOffer = {}) => {
  return finalOffer.offer_amount || null
}

export const isFinalOfferPending = (biddingStatus, finalOffer = {}) => {
  return (
    hasFinalOffer(finalOffer) &&
    !biddingStatus.hasUserWonAuction &&
    moment().isBefore(getExpireDate(finalOffer))
  )
}
